<template>
  <v-card>
    <v-card-text>
      <h1 class="title mb-1">Gestão de ofertas</h1>
      <p class="primary-text">
        Se sua campanha está divulgando um encarte de ofertas previamente criado na plataforma Mercafacil, você não precisa selecionar seus produtos e segmentos
        uma outra vez, basta selecionar a campanha de gestão de ofertas por aqui, e nós puxamos seu público-alvo e seus produtos pra cá. Assim fica tudo muito
        mais fácil!
      </p>

      <v-card color="cinza-l90">
        <v-card-text v-if="existOfferSchedule">
          <h2 class="card-title pl-0">{{ offerSchedule.name }}</h2>
          <p class="texto-corrido-pequeno">
            {{ offerSchedule.start_date | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}
            -
            {{ offerSchedule.end_date | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}
          </p>
          <p class="texto-corrido mb-0">{{ offerSchedule.description }}</p>
        </v-card-text>
      </v-card>

      <section v-if="existOfferSchedule" class="d-flex flex-column align-start mt-5">
        <tooltip align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
          <mf-button color="vermelho-d20" class="mb-3" outlined :disabled="disabled" label="Desvincular" @click="unlinkOfferScheduleInCampaign" />
        </tooltip>
        <tooltip align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
          <mf-button :disabled="disabled" label="Trocar oferta" @click="openOfferScheduleModal" />
        </tooltip>
      </section>
      <section v-else>
        <tooltip align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
          <mf-button class="mt-5" :disabled="disabled" label="Selecionar oferta" @click="openOfferScheduleModal" />
        </tooltip>
      </section>
    </v-card-text>

    <offer-schedule-modal
      v-model="offerScheduleDialog"
      :linked-offer-schedule="offerSchedule"
      :block-offers-types="blockOffersTypes"
      :hide-personalized="hidePersonalized"
    />

    <div v-if="hasSelectedProducts" class="px-3 pb-5">
      <mf-info-card
        class="mt-5"
        description="O botão de selecionar oferta está bloqueado devido aos produtos selecionados. Para desbloquear, desvincule os produtos primeiro."
        icon="warning"
        variant="warning"
      />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'OfferScheduleCard',
  inject: ['unlinkOfferScheduleInCampaign'],
  components: {
    OfferScheduleModal: () => import('@/modules/campanhas/views/components/edit/OfferScheduleModal.vue'),
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    offerSchedule: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    hasSelectedProducts: {
      type: Boolean,
      default: false,
    },
    blockOffersTypes: {
      type: Array,
      default: () => [],
    },
    hidePersonalized: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    offerScheduleDialog: false,
  }),
  computed: {
    existOfferSchedule() {
      return Object.entries(this.offerSchedule).length > 0
    },
  },
  methods: {
    openOfferScheduleModal() {
      this.offerScheduleDialog = true
    },
  },
}
</script>
